import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "history-view" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "search-form row g-2 align-items-start" }
const _hoisted_6 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_7 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_8 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_9 = { class: "col-12 col-md-6 col-xl-auto" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "errors" }
const _hoisted_12 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_13 = {
  key: 0,
  id: "steps",
  class: "controls"
}
const _hoisted_14 = { id: "controls" }
const _hoisted_15 = { class: "controls-btn-container" }
const _hoisted_16 = {
  key: 0,
  class: "bi bi-lock-fill"
}
const _hoisted_17 = {
  key: 1,
  class: "bi bi-lock"
}
const _hoisted_18 = {
  key: 0,
  class: "bi bi-chevron-down"
}
const _hoisted_19 = {
  key: 1,
  class: "bi bi-chevron-up"
}
const _hoisted_20 = { class: "info-distance-container" }
const _hoisted_21 = { class: "info-item info-distance" }
const _hoisted_22 = { class: "info-item info-distance" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "info-item info-heading" }
const _hoisted_26 = { class: "info-item info-ignition" }
const _hoisted_27 = { class: "info-item info-speed" }
const _hoisted_28 = { class: "info-geo-coordinates-container" }
const _hoisted_29 = { class: "info-item info-geo-coordinates" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "map-section" }
const _hoisted_33 = {
  key: 0,
  class: "map-loading-container"
}
const _hoisted_34 = { class: "loading-text" }
const _hoisted_35 = {
  key: 2,
  id: "functions"
}
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  class: "no-data-message"
}
const _hoisted_41 = { class: "alert alert-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_QuickRangeButtons = _resolveComponent("QuickRangeButtons")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_Map = _resolveComponent("Map")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_DailySummary = _resolveComponent("DailySummary")!
  const _component_RouteReport = _resolveComponent("RouteReport")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, null, {
      "tab-selector": _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_HISTORY }, "tab-link"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab(_ctx.TAB_HISTORY)))
        }, _toDisplayString(_ctx.$t('components.history.tabs.history')), 3),
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_SUMMARY }, "tab-link"]),
          disabled: !_ctx.route.length,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_SUMMARY)))
        }, _toDisplayString(_ctx.$t('components.history.tabs.summary')), 11, _hoisted_2),
        _cache[25] || (_cache[25] = _createTextVNode(" " + _toDisplayString('' /* wyłączone podsumowanie daily */) + " ", -1)),
        false
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_DAILY_SUMMARY }, "tab-link"]),
              disabled: !_ctx.route.length,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab(_ctx.TAB_DAILY_SUMMARY)))
            }, _toDisplayString(_ctx.$t('components.history.tabs.dailySummary')), 11, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_ROUTE_REPORT }, "tab-link"]),
          disabled: !_ctx.allPropsPassed,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTab(_ctx.TAB_ROUTE_REPORT)))
        }, _toDisplayString(_ctx.$t('components.history.tabs.routeReport')), 11, _hoisted_4)
      ]),
      "tab-content": _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startDate) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.startDate.$error, 'is-invalid': _ctx.v.startDate.$error }),
                placeholder: _ctx.$t('components.datepicker.startPlaceholder'),
                type: 'datetime',
                range: false,
                onEmitDate: _ctx.emitStartDate,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.endDate.$error, 'is-invalid': _ctx.v.endDate.$error }),
                placeholder: _ctx.$t('components.datepicker.endPlaceholder'),
                type: 'datetime',
                range: false,
                onEmitDate: _ctx.emitEndDate,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_vue_select, {
                modelValue: _ctx.v.imei.$model,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v.imei.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.imei.$error, 'is-invalid': _ctx.v.imei.$error }),
                options: _ctx.vehicles,
                icon: "bi bi-truck",
                label: "label",
                onUpdateSelect: _ctx.emitVehicle
              }, null, 8, ["modelValue", "class", "options", "onUpdateSelect"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.clickState !== _ctx.constants.RUNNING)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success btn-search w-100",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.searchRoutes && _ctx.searchRoutes(...args)))
                  }, _toDisplayString(_ctx.$t('components.search')), 1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-success btn-search btn-search-disabled w-100",
                    title: _ctx.$t('components.history.tooltip'),
                    "data-bs-toggle": "tooltip",
                    disabled: ""
                  }, _toDisplayString(_ctx.$t('components.search')), 9, _hoisted_10))
            ])
          ]),
          _createVNode(_component_QuickRangeButtons, { onRangeSelected: _ctx.applyQuickRange }, null, 8, ["onRangeSelected"]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.v.startDate.$error || _ctx.v.endDate.$error || _ctx.v.imei.$error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('customValidators.allMustBeCompleted')), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showControls)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_vue_slider, {
                  modelValue: _ctx.showRouteParameter,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showRouteParameter) = $event)),
                  clickable: false,
                  lazy: true,
                  max: _ctx.route.length - 1,
                  tooltip: "none",
                  onDragging: _cache[9] || (_cache[9] = (value) => this.propRouteParameter = value)
                }, null, 8, ["modelValue", "max"]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "btn btn-control",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clickState === _ctx.constants.SHOW_FULL_ROUTE ? _ctx.setClickState(_ctx.constants.HIDE_FULL_ROUTE) : _ctx.setClickState(_ctx.constants.SHOW_FULL_ROUTE)))
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("i", { class: "bi bi-pin-map-fill" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-control",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.locked = !_ctx.locked))
                    }, [
                      (_ctx.locked)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                        : (_openBlock(), _createElementBlock("i", _hoisted_17))
                    ]),
                    (_ctx.clickState !== _ctx.constants.RUNNING)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-control",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setClickState(_ctx.constants.RUNNING)))
                        }, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("i", { class: "bi bi-play-fill" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.clickState === _ctx.constants.RUNNING)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-control",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setClickState(_ctx.constants.PAUSED)))
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "bi bi-pause-fill" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-control",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setClickState(_ctx.constants.STOPPED)))
                    }, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("i", { class: "bi bi-stop-fill" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-control",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setAnimationDelay(1)))
                    }, [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "bi bi-chevron-double-left" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-control",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setAnimationDelay(-1)))
                    }, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "bi bi-chevron-double-right" }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "btn btn-control toogle-controls-btn",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleInfo && _ctx.toggleInfo(...args)))
                    }, [
                      (_ctx.isInfoMinimized)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                        : (_openBlock(), _createElementBlock("i", _hoisted_19))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[32] || (_cache[32] = _createElementVNode("i", { class: "bi bi-signpost-2-fill" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.history.totalMapDistance')) + ": " + _toDisplayString(_ctx.formattedTotalMapDistance) + " km", 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[33] || (_cache[33] = _createElementVNode("i", { class: "bi bi-signpost-2-fill" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.history.totalCanDistance')) + ": " + _toDisplayString(_ctx.formattedTotalCanDistance) + " km", 1)
                    ])
                  ]),
                  (_ctx.showControls)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ display: _ctx.isInfoMinimized ? 'none' : '' }),
                        id: "info"
                      }, [
                        _withDirectives(_createElementVNode("div", _hoisted_23, [
                          _cache[34] || (_cache[34] = _createElementVNode("i", { class: "bi bi-clock-fill" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getHumanDateTime(_ctx.additionalRouteParameters[_ctx.showRouteParameter].device_timestamp)), 1)
                        ], 512), [
                          [_vShow, !_ctx.isInfoMinimized]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_24, [
                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "bi bi-chevron-double-right" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.animationDelayValues[_ctx.animationDelayValues.findIndex(index => index.value === _ctx.animationDelay)].key) + "x", 1)
                        ], 512), [
                          [_vShow, !_ctx.isInfoMinimized]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_25, [
                          _cache[36] || (_cache[36] = _createElementVNode("i", { class: "bi bi-signpost-split-fill" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.additionalRouteParameters[_ctx.showRouteParameter].heading) + "°", 1)
                        ], 512), [
                          [_vShow, !_ctx.isInfoMinimized]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_26, [
                          _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-key-fill" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.additionalRouteParameters[_ctx.showRouteParameter].ignition ? _ctx.$t('components.history.on') : _ctx.$t('components.history.off')), 1)
                        ], 512), [
                          [_vShow, !_ctx.isInfoMinimized]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_27, [
                          _cache[38] || (_cache[38] = _createElementVNode("i", { class: "bi bi-speedometer" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.additionalRouteParameters[_ctx.showRouteParameter].basic_speed) + " km/h", 1)
                        ], 512), [
                          [_vShow, !_ctx.isInfoMinimized]
                        ])
                      ], 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("div", _hoisted_29, [
                      _cache[39] || (_cache[39] = _createElementVNode("i", { class: "bi bi-compass-fill" }, null, -1)),
                      (_ctx.clickState !== _ctx.constants.RUNNING && _ctx.additionalRouteParameters[_ctx.showRouteParameter].address)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.additionalRouteParameters[_ctx.showRouteParameter].address), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.additionalRouteParameters[_ctx.showRouteParameter].lat + ', ' + _ctx.additionalRouteParameters[_ctx.showRouteParameter].lng), 1))
                    ], 512), [
                      [_vShow, !_ctx.isInfoMinimized]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.mapLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createVNode(_component_ScaleLoader),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('components.history.loadingMap')), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.mapLoading)
              ? (_openBlock(), _createBlock(_component_Map, {
                  key: _ctx.reloaded,
                  ref: "map",
                  "additional-route-parameters": _ctx.additionalRouteParameters,
                  "animation-delay": _ctx.animationDelay,
                  "click-state": _ctx.clickState,
                  locked: _ctx.locked,
                  "matched-route": _ctx.matchedRoute,
                  "prop-animation-pos": _ctx.propRouteParameter,
                  route: _ctx.route,
                  "show-icons": false,
                  "disable-last-vehicles-pos": true,
                  onEmitAnimationPos: _cache[18] || (_cache[18] = (val) => this.showRouteParameter = val),
                  onShowControls: _ctx.setControlsState,
                  onUpdateClickState: _cache[19] || (_cache[19] = (val) => _ctx.setClickState(val)),
                  onUpdateLocked: _cache[20] || (_cache[20] = (val) => this.locked = val)
                }, null, 8, ["additional-route-parameters", "animation-delay", "click-state", "locked", "matched-route", "prop-animation-pos", "route", "onShowControls"]))
              : _createCommentVNode("", true),
            (_ctx.showControls && !_ctx.mapLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "btn btn-success btn-control",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.exportCsv(_ctx.additionalRouteParameters, 'route_' + _ctx.getHumanDate(Date.now() / 1000))))
                  }, [...(_cache[40] || (_cache[40] = [
                    _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "btn btn-success btn-control",
                    style: {"padding":"5px 13px 5px 7px"},
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.clickState === _ctx.constants.SHOW_ROUTE_POINTS ? _ctx.setClickState(_ctx.constants.HIDE_ROUTE_POINTS) : _ctx.setClickState(_ctx.constants.SHOW_ROUTE_POINTS)))
                  }, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("i", { class: "bi bi-hand-index" }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "btn btn-success btn-control",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.downloadMapPng && _ctx.downloadMapPng(...args))),
                    title: _ctx.$t('components.history.downloadMap')
                  }, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("i", { class: "bi bi-image" }, null, -1)
                  ]))], 8, _hoisted_36),
                  _createElementVNode("button", {
                    class: "btn btn-success btn-control",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.generateReport && _ctx.generateReport(...args))),
                    title: _ctx.$t('components.history.generateReport')
                  }, [...(_cache[43] || (_cache[43] = [
                    _createElementVNode("i", { class: "bi bi-file-earmark-pdf" }, null, -1)
                  ]))], 8, _hoisted_37)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_HISTORY]
        ]),
        (_ctx.allPropsPassed)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
              (_openBlock(), _createBlock(_component_Summary, {
                key: _ctx.reloaded,
                "date-from": _ctx.startDate,
                "date-to": _ctx.endDate,
                imei: _ctx.imei,
                vehicle: _ctx.vehicle,
                onSummaryDataLoaded: _ctx.onSummaryDataLoaded
              }, null, 8, ["date-from", "date-to", "imei", "vehicle", "onSummaryDataLoaded"]))
            ], 512)), [
              [_vShow, _ctx.tabContent === _ctx.TAB_SUMMARY]
            ])
          : _createCommentVNode("", true),
        _cache[45] || (_cache[45] = _createTextVNode(" " + _toDisplayString('' /* wyłączone podsumowanie daily */) + " ", -1)),
        false
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_openBlock(), _createBlock(_component_DailySummary, {
                key: _ctx.reloaded,
                "date-from": _ctx.startDate,
                "date-to": _ctx.endDate,
                imei: _ctx.imei,
                vehicle: _ctx.vehicle
              }, null, 8, ["date-from", "date-to", "imei", "vehicle"]))
            ], 512)), [
              [_vShow, _ctx.tabContent === _ctx.TAB_DAILY_SUMMARY]
            ])
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", null, [
          (_ctx.allPropsPassed)
            ? (_openBlock(), _createBlock(_component_RouteReport, {
                key: _ctx.reloaded,
                "date-from": _ctx.startDate,
                "date-to": _ctx.endDate,
                imei: _ctx.imei,
                vehicle: _ctx.vehicle
              }, null, 8, ["date-from", "date-to", "imei", "vehicle"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[44] || (_cache[44] = _createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.history.routeReport.noDataMessage')), 1)
                ])
              ]))
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_ROUTE_REPORT]
        ])
      ]),
      _: 1
    })
  ]))
}